import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";

import { IAngularMyDpOptions, IMyDateModel } from "angular-mydatepicker";

import { HeaderService } from "../../services";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  @Output() outDate = new EventEmitter();

  title;
  subTitle;
  datePicker;

  userMenu = false;

  today = "Hoje";

  dayLabelsString = {
    su: "Dom",
    mo: "Seg",
    tu: "Ter",
    we: "Qua",
    th: "Qui",
    fr: "Sex",
    sa: "Sáb",
  };
  monthLabelsString = {
    1: "Jan",
    2: "Fev",
    3: "Mar",
    4: "Abr",
    5: "Mai",
    6: "Jun",
    7: "Jul",
    8: "Ago",
    9: "Set",
    10: "Out",
    11: "Nov",
    12: "Dez",
  };

  datePickerOptions: IAngularMyDpOptions = {
    dateFormat: "dd/mm/yyyy",
    showSelectorArrow: false,
    selectorWidth: "220px",
    selectorHeight: "200px",
    dayLabels: this.dayLabelsString,
    monthLabels: this.monthLabelsString,
  };

  datePickerModel = {
    date: {
      year: 2018,
      month: 1,
      day: 10,
    },
  };

  userName;

  constructor(private headerService: HeaderService, private router: Router) {}

  ngOnInit() {
    this.headerService.title.subscribe((value) => {
      this.title = value;
    });

    this.headerService.subTitle.subscribe((value) => {
      this.subTitle = value;
    });

    this.headerService.datePicker.subscribe((value) => {
      this.datePicker = value;
    });

    this.userName = localStorage.getItem("userName");

    this.todayDate();
  }

  todayDate() {
    let date = new Date();

    this.datePickerModel = {
      date: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
    };

    this.outDate.emit(
      `${("00" + this.datePickerModel.date.day).slice(-2)}/${(
        "00" + this.datePickerModel.date.month
      ).slice(-2)}/${this.datePickerModel.date.year}`
    );
  }

  openUserMenu(bol) {
    if (!bol) {
      this.userMenu = bol;
    } else {
      this.userMenu = !this.userMenu;
    }
  }

  datePickerChanged(event: IMyDateModel) {
    let date = new Date();

    if (
      event.singleDate.date.day == date.getDate() &&
      event.singleDate.date.month == date.getMonth() + 1
    ) {
      this.today = "Hoje";
    } else {
      this.today = `${("00" + event.singleDate.date.day).slice(-2)}/${(
        "00" + event.singleDate.date.month
      ).slice(-2)}/${event.singleDate.date.year}`;
    }

    this.outDate.emit(event.singleDate.formatted);
  }

  logout() {
    localStorage.clear();

    this.router.navigate(["/login"]);
  }
}
